import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components/native';
import images from '../assets/images';
import Colors from '../colors';
import Text from '../text';
const Loader = styled.View`
  display: flex;
  flex: 1;
  width: 100%;
  height: 100%;
  align-items: center;
  justify-content: center;
  ${props => props.customStyles}
`;
const ContentWrapper = styled.View`
  align-items: center;
  justify-content: center;
  ${props => props.customStyles}
`;
const StyledImage = styled.Image`
  width: ${props => props.width};
  height: ${props => props.height};
  ${props => props.customStyles}
`;
export default function withLoader(Component) {
  function WithLoader(props) {
    if (props.isLoading) {
      return /*#__PURE__*/React.createElement(Loader, {
        customStyles: props.loaderStyle
      }, /*#__PURE__*/React.createElement(ContentWrapper, {
        customStyles: props.wrapperStyle
      }, /*#__PURE__*/React.createElement(StyledImage, {
        source: images.AdvanceLoader,
        width: props.imageWidth,
        height: props.imageHeight,
        resizeMode: props.imageResizeMode,
        customStyles: props.imageStyle
      }), /*#__PURE__*/React.createElement(Text.BodySmall, {
        align: "center",
        color: Colors.gray300
      }, "Please wait while we load your content")));
    }

    return /*#__PURE__*/React.createElement(Component, props);
  }

  WithLoader.defaultProps = {
    loaderStyle: {},
    wrapperStyle: {},
    imageStyle: {},
    imageWidth: '39px',
    imageHeight: '71px',
    imageResizeMode: 'contain'
  };
  WithLoader.propTypes = {
    isLoading: PropTypes.bool.isRequired,
    loaderStyle: PropTypes.object,
    wrapperStyle: PropTypes.object,
    imageStyle: PropTypes.object,
    imageWidth: PropTypes.string,
    imageHeight: PropTypes.string,
    imageResizeMode: PropTypes.string
  };
  return WithLoader;
}
//# sourceMappingURL=with-loader.js.map